import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Полтавець Євген',
  role: 'Голова комісії з класифікації маршрутів',
  email: 'e.poltavets@umcf.org.ua'
}, {
  name: 'Венславовський Дмитро',
  role: 'Член комісії з класифікації маршрутів',
  email: 'stalker.vd@gmail.com'
}, {
  name: 'Поддубнов Михайло',
  role: 'Член комісії з класифікації маршрутів'
}];
export function RouteClassificationCommission() {
  return <FederationMembersPage title="Комісія з класифікації маршрутів" subtitle="Комісія з класифікації маршрутів комітету альпінізму ФАіСУ" members={members} data-id="element-424" />;
}